// @flow

import React, { type Node } from 'react';
import styled  from 'styled-components';
import { PlaceOrderButton } from './place-order-button';
import { BackToShopifyButton } from './back-to-shopify-button';

export function FormButtons(): Node {
  return (
    <FormButtonsWrapper>
      <PlaceOrderButton />
      <BackToShopifyButton />
    </FormButtonsWrapper>
  );
}

const FormButtonsWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  margin: 20px 10px 0 10px;
  box-sizing: border-box;
  @media (min-width: 990px) {
    margin: 20px 0 0 0;
  }
`;
